export default __webpack_public_path__ + "static/m4h-024fd576c94e74c2c90ccf224e26ff79.webp";